import { eventEmitter, type ShowAlertDialogPayload } from '@/lib/eventEmitter.ts';

export const showAlertDialogAsync = (
    options: Omit<ShowAlertDialogPayload, 'continueCallback' | 'cancelCallback'>,
) => {
    return new Promise((resolve) => {
        eventEmitter.emit('showAlertDialog', {
            title: options.title,
            description: options.description,
            actionText: options.actionText,
            cancelText: options.cancelText,
            continueCallback: () => resolve(true), // Resolves when user continues
            cancelCallback: () => resolve(false), // Resolves when user cancels
        });
    });
};
